import React from "react";

const starDots = [
  { top: "7%", left: "8%", size: 2, delay: "0s", duration: "3.8s" },
  { top: "10%", left: "18%", size: 3, delay: "1.1s", duration: "4.2s" },
  { top: "14%", left: "31%", size: 2, delay: "0.8s", duration: "5s" },
  { top: "16%", left: "74%", size: 3, delay: "1.7s", duration: "4.4s" },
  { top: "20%", left: "84%", size: 2, delay: "0.2s", duration: "5.2s" },
  { top: "24%", left: "11%", size: 4, delay: "2.1s", duration: "4.8s" },
  { top: "28%", left: "24%", size: 2, delay: "2.8s", duration: "5.6s" },
  { top: "30%", left: "66%", size: 3, delay: "0.5s", duration: "4.2s" },
  { top: "34%", left: "91%", size: 2, delay: "1.3s", duration: "5.4s" },
  { top: "40%", left: "8%", size: 3, delay: "0.6s", duration: "4.5s" },
  { top: "44%", left: "19%", size: 2, delay: "3.1s", duration: "5.8s" },
  { top: "48%", left: "36%", size: 4, delay: "0.4s", duration: "4.1s" },
  { top: "52%", left: "78%", size: 3, delay: "1.6s", duration: "4.9s" },
  { top: "56%", left: "89%", size: 2, delay: "2.4s", duration: "5.7s" },
  { top: "62%", left: "14%", size: 3, delay: "0.7s", duration: "4.7s" },
  { top: "66%", left: "28%", size: 2, delay: "1.9s", duration: "5.5s" },
  { top: "70%", left: "58%", size: 3, delay: "0.3s", duration: "4.3s" },
  { top: "74%", left: "83%", size: 4, delay: "2.7s", duration: "5.1s" },
  { top: "79%", left: "9%", size: 2, delay: "1.4s", duration: "5.6s" },
  { top: "84%", left: "21%", size: 3, delay: "0.9s", duration: "4.9s" },
  { top: "88%", left: "43%", size: 2, delay: "2.2s", duration: "5.4s" },
  { top: "91%", left: "72%", size: 3, delay: "1.1s", duration: "4.6s" },
  { top: "94%", left: "90%", size: 2, delay: "2.9s", duration: "5.2s" },
];

const shootingStars = [
  { top: "12%", left: "82%", delay: "0s", duration: "6.5s" },
  { top: "22%", left: "66%", delay: "2.2s", duration: "7.2s" },
  { top: "35%", left: "90%", delay: "4.1s", duration: "6.8s" },
  { top: "54%", left: "72%", delay: "1.5s", duration: "7.4s" },
  { top: "68%", left: "88%", delay: "3.8s", duration: "6.9s" },
  { top: "82%", left: "64%", delay: "5.1s", duration: "7.7s" },
];

export const panelClass = "rounded-[1.9rem] border border-white/10 bg-[linear-gradient(180deg,rgba(22,46,82,0.62),rgba(8,18,37,0.92))] shadow-[0_24px_70px_rgba(0,0,0,0.32)] backdrop-blur-sm";
export const softPanelClass = "rounded-[1.5rem] border border-white/10 bg-[linear-gradient(180deg,rgba(24,53,95,0.46),rgba(9,19,36,0.9))] shadow-[0_20px_50px_rgba(0,0,0,0.25)] backdrop-blur-sm";
export const pillClass = "rounded-full border border-cyan-300/18 bg-[linear-gradient(180deg,rgba(36,88,152,0.34),rgba(11,23,48,0.6))] text-slate-100 shadow-[0_12px_30px_rgba(0,0,0,0.22)]";
export const ctaSectionClass = "rounded-[2rem] border border-cyan-300/14 bg-[linear-gradient(180deg,rgba(14,45,88,0.58),rgba(8,19,36,0.94))] shadow-[0_28px_80px_rgba(0,0,0,0.34)] backdrop-blur-sm";

export default function MarketingBackdrop({ children, className = "" }) {
  return (
    <div className={`relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top,rgba(34,211,238,0.16),transparent_20%),radial-gradient(circle_at_18%_28%,rgba(59,130,246,0.13),transparent_28%),linear-gradient(180deg,#07152d_0%,#0a2344_32%,#081b35_65%,#061224_100%)] text-white ${className}`}>
      <style>{`
        .marketing-starfield::before,
        .marketing-starfield::after {
          content: "";
          position: absolute;
          inset: 0;
          background-image:
            radial-gradient(circle at 12% 24%, rgba(255,255,255,0.88) 0 1px, transparent 1.6px),
            radial-gradient(circle at 28% 68%, rgba(255,255,255,0.72) 0 1px, transparent 1.7px),
            radial-gradient(circle at 74% 32%, rgba(255,255,255,0.82) 0 1px, transparent 1.5px),
            radial-gradient(circle at 86% 76%, rgba(255,255,255,0.7) 0 1px, transparent 1.6px),
            radial-gradient(circle at 58% 14%, rgba(125,211,252,0.64) 0 1px, transparent 1.7px),
            radial-gradient(circle at 42% 88%, rgba(34,211,238,0.4) 0 1px, transparent 1.8px);
          opacity: 0.54;
          animation: marketingDriftStars 34s linear infinite;
          pointer-events: none;
        }
        .marketing-starfield::after {
          opacity: 0.28;
          transform: scale(1.14);
          animation-duration: 46s;
          animation-direction: reverse;
        }
        @keyframes marketingDriftStars {
          0% { transform: translate3d(0,0,0); }
          50% { transform: translate3d(-2%, 1.4%, 0); }
          100% { transform: translate3d(-4%, 2.8%, 0); }
        }
        @keyframes marketingTwinkle {
          0%, 100% { opacity: 0.3; transform: scale(0.95); }
          50% { opacity: 1; transform: scale(1.5); }
        }
        @keyframes marketingShootingStar {
          0% { transform: translate3d(0,0,0) rotate(18deg); opacity: 0; }
          7% { opacity: 1; }
          32% { opacity: 0.28; }
          100% { transform: translate3d(-420px, 220px, 0) rotate(18deg); opacity: 0; }
        }
      `}</style>
      <div className="marketing-starfield absolute inset-0" />
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {starDots.map((star, index) => (
          <span
            key={`m-star-${index}`}
            className="absolute rounded-full bg-white shadow-[0_0_18px_rgba(255,255,255,0.95)]"
            style={{
              top: star.top,
              left: star.left,
              width: `${star.size}px`,
              height: `${star.size}px`,
              animation: `marketingTwinkle ${star.duration} ease-in-out ${star.delay} infinite`,
            }}
          />
        ))}
        {shootingStars.map((star, index) => (
          <span
            key={`m-shoot-${index}`}
            className="absolute h-[2px] w-32 rounded-full bg-[linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,0.95),rgba(34,211,238,0.28),rgba(34,211,238,0))] opacity-0"
            style={{
              top: star.top,
              left: star.left,
              animation: `marketingShootingStar ${star.duration} linear ${star.delay} infinite`,
              boxShadow: "0 0 24px rgba(125,211,252,0.72)",
            }}
          />
        ))}
      </div>
      {children}
    </div>
  );
}
